export default {
  SET_CONTRACTS_LIST(state, data) {
    state.contracts = data
  },
  SET_ONE_CONTRACTS(state, data) {
    state.oneContract = data
  },
  SET_CHECKED_MATERIAL_IDS(state, data) {
    state.checkedMaterialIds = data
  },
  SET_CHECKED_MATERIAL_IDS_FOR_EDIT(state, data) {
    state.checkedMaterialIdsForEdit = data
  },
  SET_CHECKED_INSTRUMENT_IDS(state, data) {
    state.checkedInstrumentIds = data
  },
  SET_CHECKED_INSTRUMENT_IDS_FOR_EDIT(state, data) {
    state.checkedInstrumentIdsForEdit = data
  },
  SET_MATERIAL_ITEMS(state, data) {
    state.materialItems = data
  },
  SET_MATERIAL_ITEMS_FOR_EDIT(state, data) {
    state.materialItemsForEdit = data
  },
  SET_INSTRUMENT_ITEMS(state, data) {
    state.instrumentItems = data
  },
  SET_INSTRUMENT_ITEMS_FOR_EDIT(state, data) {
    state.instrumentItemsForEdit = data
  },
  SET_INVOICE_ITEMS(state, data) {
    state.invoiceItems = data
  },
  SET_INVOICE_ID(state, data) {
    state.invoice_id = data
  },
  SET_MATERIAL_AND_INSTRUMENT_ITEMS(state, data) {
    state.materialAndInstrumentApplications = data
  },
  SET_MATERIAL_AND_INSTRUMENT_ITEMS_FOR_EDIT(state, data) {
    state.materialAndInstrumentApplicationsForEdit = data
  },
  SET_CONTRACT(state, data) {
    state.contract = data
  },
  SET_VIEW_MODE(state, data) {
    state.viewMode = data
  },
  SET_CONTRACT_INVOICE_TYPE(state, data) {
    state.addContractInvoiceType = data
  },
  SET_NEW_CONTRACT_INVOICE(state, data) {
    state.addNewContractInvoice = data
  },
  
  
  
  
  PUSH_FILES(state, data) {
    state.files.push(data)
  },
  SET_FILES(state, data) {
    state.files = data
  },
  PUSH_CONTRACT_FILES(state, data) {
    state.contractFiles.push(data)
  },
  SET_CONTRACT_FILES(state, data) {
    state.contractFiles = data
  },


  SET_REFRESH_AGREEMENT(state, data) {
    state.refreshAgreement = data
  },
}
